import { Star } from "@phosphor-icons/react";

export default function StarRating({ value = 1, onChange, size = 20, testid, readOnly = false }) {
  const interactive = !readOnly && typeof onChange === "function";
  return (
    <div className="flex gap-0.5" data-testid={testid || "star-rating"}>
      {[1, 2, 3].map((n) => {
        const active = n <= value;
        const star = (
          <Star
            size={size}
            weight={active ? "fill" : "regular"}
            color={active ? "var(--cf-warning)" : "var(--cf-border-strong)"}
          />
        );
        if (!interactive) {
          return (
            <span key={n} data-testid={`star-${n}`} className="inline-flex">
              {star}
            </span>
          );
        }
        return (
          <button
            key={n}
            type="button"
            onClick={(e) => { e.stopPropagation(); onChange(n); }}
            className="transition-transform active:scale-90 p-0.5"
            data-testid={`star-${n}`}
            aria-label={`${n} étoile${n > 1 ? "s" : ""}`}
          >
            {star}
          </button>
        );
      })}
    </div>
  );
}
